import React from "react";
import {Mail, PhoneCall, Clock3, MapPin} from "lucide-react";

export const Contact = () => {
    return (
        <section className='contact-section' id='contact'>

            <div className='section-content'>
                <div className='contact-panel'>
                    <h2 className='section-title'>Get In Touch</h2>
                    <p className='contact-intro'>
                        From breakdowns and diagnostics to full on-site repairs, we&apos;ve got you covered. Contact us today for fast, reliable mobile mechanic service.
                    </p>

                    <div className='contact-list'>
                        <a href='tel:+14804425228' className='contact-row contact-call-button'>
                            <span className='contact-icon'><PhoneCall/></span>
                            <span className='contact-text'>Call Now (480) 442-5228</span>
                        </a>

                        <a href='mailto:brian@aplusroadsiderescue.com' className='contact-row'>
                            <span className='contact-icon'><Mail/></span>
                            <span className='contact-text'>brian@aplusroadsiderescue.com</span>
                        </a>

                        <div className='contact-row'>
                            <span className='contact-icon'><Clock3/></span>
                            <span className='contact-text'>Monday - Sunday, 8am-10pm </span>
                        </div>

                        <div className='contact-row'>
                            <span className='contact-icon'><MapPin/></span>
                            <span className='contact-text'>Phoenix, Arizona</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
